import { createContext } from 'react';
import type { UnsavedEditArea } from '../lib/UnsavedEditArea';

/** Ближайшая область правок (`UnsavedEditScope`); без неё правки не защищены, уход не спрашивает. */
export const UnsavedEditContext = createContext<UnsavedEditArea | null>(null);
